import {Form, InputGroup} from "@themesberg/react-bootstrap";
import label from 'enqc-utilities/src/label/Label'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelope, faPhone} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import PropTypes from 'prop-types';
import {cleanPhoneNumber} from "enqc-utilities/src/utils/Utilities";

export default class PhoneNumberInput extends React.Component{

    render() {
        let {id, placeholder, label, value, readOnly, icon, isError, errorMessage} = this.props
        if(!id){
            id = "text"
        }
        if(!label){
            label = ""
        }
        if(!placeholder){
            placeholder = label
        }
        return (
            <Form.Group id={id} className="mb-4">
                <Form.Label>{label}</Form.Label>
                <InputGroup>
                    {icon&&(
                        <InputGroup.Text style={{borderColor:(isError?'#FA5252':'')}}>
                            <FontAwesomeIcon icon={icon} />
                        </InputGroup.Text>
                    )}
                    <Form.Control
                        autoFocus
                        required={this.props.required}
                        type="text"
                        placeholder={placeholder}
                        onChange={(e)=>{
                            if(this.props.onChange){
                                let value = cleanPhoneNumber(e.target.value)
                                this.props.onChange(value)
                            }
                        }}
                        isInvalid={isError}
                        value={value?value:""} readOnly={readOnly}/>
                </InputGroup>
                {isError&&(
                    <Form.Control.Feedback type="invalid" style={{display:'unset', position:'absolute'}}>{errorMessage?errorMessage:placeholder}</Form.Control.Feedback>
                )}
            </Form.Group>
        );
    }
}
PhoneNumberInput.propTypes = {
    label:PropTypes.string.isRequired,
    value:PropTypes.string,
    placeholder:PropTypes.string,
    icon:PropTypes.any,
    required:PropTypes.bool,
    readOnly:PropTypes.bool,
    onChange:PropTypes.func,
    isError:PropTypes.bool,
    errorMessage:PropTypes.string
}